export const DEFAULT_FORM_VALUES = {
  brand: '',
  displayDateRange: '',
  startTime: null,
  endTime: null,
  title: '',
  productHighlight: [],
  sections: [
    {
      title: 'Preparation',
      description: '',
      orderIndex: 1,
    },
    {
      title: 'Opening',
      description: '',
      orderIndex: 2,
    },
    {
      title: 'Segmen Selling',
      description: '',
      orderIndex: 3,
    },
    {
      title: 'Closing',
      description: '',
      orderIndex: 4,
    },
  ],
};

